export const Roles = {
    STUDENT_NAME: 'student',
    RECRUITER_NAME: 'recruiter',
    COUNSELOR_NAME: 'counselor',
    ADMIN_NAME: 'admin',
    SCHOOL_IT_NAME: 'school_it',
}